const SimulationNeedsExtraForm = () => null;

export default SimulationNeedsExtraForm;
